/** Shared catalogue reads (api-contract.md §8) — any authenticated role. */

import type { UploadRule } from "../lib/uploadRules";
import { apiFetch } from "./client";

/** The units the API accepts, read from the database enum (public). */
export const getUnitKinds = (): Promise<{ unit_kinds: string[] }> => apiFetch("/api/v1/system/unit-kinds");

export interface CatalogueMedicine {
  id: string;
  name: string;
  brand: string | null;
  schedule_class: string;
  mrp: string;
  default_gst_pct: string;
  unit: string;
  unit_kind: string;
  active: boolean;
}

export const searchCatalogueMedicines = (q?: string, signal?: AbortSignal): Promise<CatalogueMedicine[]> =>
  apiFetch(`/api/v1/catalogue/medicines${q?.trim() ? `?q=${encodeURIComponent(q.trim())}` : ""}`, { signal });

export interface CatalogueStatus {
  id: string;
  code: string;
  label: string;
  colour_token: string | null;
  /** Delivered, cancelled, … — the order is finished (pharmacist Mine → Completed). */
  is_final: boolean;
  active: boolean;
  display_order: number;
}

export const listCatalogueStatuses = (): Promise<CatalogueStatus[]> =>
  apiFetch("/api/v1/catalogue/statuses");

export interface IndianState {
  code: string;
  name: string;
}

/** India's states and union territories by the code addresses and pharmacy settings use (ACCT-07). */
export const listStates = (): Promise<IndianState[]> => apiFetch("/api/v1/catalogue/states");

export interface UploadRules {
  prescription: UploadRule;
  support_attachment: UploadRule;
  support_attachments_per_message: number;
}

/** What each upload accepts — size and types — from the API's own check (ORD-06). */
export const getUploadRules = (): Promise<UploadRules> => apiFetch("/api/v1/catalogue/upload-rules");
